import { AppBar, Toolbar, Box, IconButton, Typography } from '@mui/material';
import arenaIcon from '../icons/arena_icon_no_text.png';
import { useNavigate, useLocation } from "react-router-dom";

import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIos from '@mui/icons-material/ArrowBackIos';

import AdminDrawer from './AdminDrawer';
import { useState, useEffect } from 'react';
import { authService } from '../../firebase/authService';

export default function Header() {

  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkAdmin = async () => {
      const uid = localStorage.getItem('admin_uid');
      if (uid) {
        const admin = await authService.isUserAdmin(uid);
        setIsAdmin(admin);
      } else {
        setIsAdmin(false);
      }
    };
    checkAdmin();
  }, [location]);

  const goTo = () => {
    navigate('/');
  };

  const goToAddNews = () => {
    navigate('/add-news');
  };

  const goToNewsList = () => {
    navigate('/news-list');
  };

  const goToSponsorManager = () => {
    navigate('/SponsorManager');
  };

  return (
    <AppBar 
      position="fixed"
      elevation={0}
      sx={{
        bgcolor: "white", 
        height: "70px",
        '@media (max-width:768px)': {
          height: '70px',
        },
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        boxShadow: 'none',
      }}
    >
      <Toolbar sx={{ display: 'flex', alignItems: 'center' }}>
        <Box
          onClick={goTo}
          sx={{
            display: 'flex',
            alignItems: 'center',
            height: 56,
            width: 'auto',
            marginLeft: {
              xs: 0,
              xl: '24vh'
            },
            cursor: 'pointer',
          }}
        >
          <IconButton sx={{mr: 3}} onClick={() => navigate(-1)}>
            <ArrowBackIos sx={{ color: '#1976d2' }} />
          </IconButton> 
          <img src={arenaIcon} alt="Logo" style={{ height: 48, width: 48, marginRight: 12 }} />
          <Typography
            variant="h6"
            sx={{
              fontFamily: 'Atlan',
              fontWeight: 'bold',
              color: '#0b2951',
              letterSpacing: 1,
              display: "block"
            }}
          >
            Arena Esporte Total
          </Typography>
        </Box>
        <Box 
          sx={{ 
            marginLeft: 'auto',
            display: 'flex',
            gap: 2,
            paddingRight:{
              xs: 0,
              xl: '24vh'
            }
          }}
        >
          {isAdmin && (
            <IconButton onClick={() => setDrawerOpen(true)}>
              <MenuIcon sx={{ color: '#1976d2' }} />
            </IconButton> 
          )}
        </Box>
        <AdminDrawer 
          open={drawerOpen} 
          onClose={() => setDrawerOpen(false)} 
          goToAddNews={goToAddNews} 
          goToNewsList={goToNewsList} 
          goToSponsorManager={goToSponsorManager}
        />
      </Toolbar>
    </AppBar>
  );
}
